import React from "react";
import { AbsoluteFill } from "../AbsoluteFill";
import { Background } from "./Background";
import { Dots } from "./Dots";
import { RedHearts } from "./RedHearts";
import { Slowed } from "./SlowedTrail";
import { Stars } from "./Stars";
import { YellowHearts } from "./YellowHearts";
 
export const FireWorks = () => {
  return (
    <AbsoluteFill>
       {/* <Background /> */}
      <Slowed>
        <Dots />
        <RedHearts />
        <YellowHearts />
        <Stars />
      </Slowed>
    </AbsoluteFill>
  );
};